import { Dialog } from 'primereact/dialog';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function DividendDialog({issue}) {
    const {t, i18n} = useTranslation();
    const [visible, setVisible] = useState(false);
    function dateFormat(date) {
        if(date) {
            date = new Date(date);
            return((date.getDate() < 10 ? "0" : "") + date.getDate() + ' ' + t(date.toLocaleString('default', { month: 'long' })) + ' ' + date.getFullYear());
        }
    }
    return (
        <>
            <span className="cursor-pointer" onClick={() => setVisible(true)}>&nbsp;{issue?.txtdiv}</span>
            <div className="flex justify-content-center">
                <Dialog header={issue?.diviSign == 2 ? t("EX-DIVIDEND") : t("DIVIDEND")} headerClassName="text-yellow-500 border-bottom-1 border-blue-700 bg-dialog" contentClassName="bg-dialog" className="w-30rem text-white border-round-2xl" visible={visible} onHide={() => setVisible(false)}>
                    <div className="grid text-white">
                        <div className="col-12 line-height-1 pb-0">
                            <div className='flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700'>
                                <span className='text-sm'>{t('Symbol')}</span>
                                <span className=' text-sm'>{issue?.stock}</span>
                            </div>
                            <div className='flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700'>
                                <span className='text-sm'>{t('Type of Dividend')}</span>
                                <span className='text-sm'>{issue?.type_of_dividend}</span>
                            </div>
                            <div className='flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700'>
                                <span className='text-sm'>{t('Dividend per share')}</span>
                                <span className='text-sm text-right'>{issue?.dividend_per_share}</span>
                            </div>
                            <div className='flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700'>
                                <span className='text-sm'><a className="no-underline text-blue-500" href="http://csx.com.kh/news/faq/listPosts.do?lang=en&MNCD=7070#sec2_91">{t('Ex-Dividend date')}</a></span>
                                <span className='text-sm'>{issue?.ex_dividend_date && dateFormat(issue.ex_dividend_date)}</span>
                            </div>
                            <div className='flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700'>
                                <span className='text-sm'>{t('Record date')}</span>
                                <span className='text-sm'>{issue?.record_date && dateFormat(issue.record_date)}</span>
                            </div>
                            <div className='flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700'>
                                <span className='text-sm'>{t('Payment date')}</span>
                                <span className='text-sm'>{issue?.payment_date && dateFormat(issue.payment_date)}</span>
                            </div>
                            <div className='flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700'>
                                <span className='text-sm'><a className="no-underline text-blue-500" href={issue?.link}>{t('Click here to learn more')}</a></span>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </div>
        </>
    )
}